import { z } from "zod";

import { FormsWrapper } from "../utils.models";

export const LadyCommonDto = z.object({
  uid: z.number(),
  wikiLink: z.string().optional(),
  chat: z.boolean().optional(),
  gifts: z.boolean().optional(),
  name: z.string(),
  photo: z.string(),
  regDate: z.boolean().optional(),
  text: z.string(),
  residence: z.string(),
  age: z.number(),
  cam: z.boolean(),
  isNewProfile: z.boolean().optional(),
  isBirthdaySoon: z.boolean().optional(),
  isOnline: z.boolean().optional(),
  hasIntroVideo: z.boolean().optional(),
});

export type LadyCommonDto = z.infer<typeof LadyCommonDto>;
export type LadyCommonDtoResponse = FormsWrapper<LadyCommonDto[]>;
